var $2599cf0c4ab37f59$exports = {};
$2599cf0c4ab37f59$exports = {
    "dismiss": `Descartar`
};


export {$2599cf0c4ab37f59$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
